import React from "react"
import { Box } from "@chakra-ui/react"
import Dropdown from "@components/Dropdown"
import { SortMethods } from "../../common"

const baseOptions = [
  {
    label: "Newest",
    value: SortMethods.ByNewest,
  },
  {
    label: "Price: High - Low",
    value: SortMethods.ByPriceDesc,
  },
  {
    label: "Price: Low - High",
    value: SortMethods.ByPriceAsc,
  },
]

const optionsWithFeatured = [
  {
    label: "Featured",
    value: SortMethods.ByFeatured,
  },
  ...baseOptions,
]

const SortDropdown: any = ({ value, onSort, hideFeatured }) => {
  const options = hideFeatured ? baseOptions : optionsWithFeatured
  const optionForValue = options.find((option) => option.value === value)
  return (
    <Box height="40px" maxW={`300px`} position="relative">
      <Dropdown
        helperText="Sort By:"
        value={value}
        options={options}
        onChange={(option) => {
          onSort(option.value)
        }}
      />
    </Box>
  )
}

export default SortDropdown
